// hooks/useLoadViewControl.ts
export const useLoadViewControl = ({ load, view, removeDOM }: { load?: boolean; view?: boolean; removeDOM?: boolean }) => {
	const showRefresh = true;
	const shouldShowContent = !load && view;
	const shouldRemoveDOM = !view && removeDOM;
	const shouldHideWithClass = !view && !removeDOM;

	return {
		showRefresh,
		shouldShowContent,
		shouldRemoveDOM,
		shouldHideWithClass,
	};
};
